module.exports = __webpack_public_path__ + "static/assets/ddb216edf89606c7505a379e46811dc6.svg";